import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';

import { RequestcallapiService } from '../services/requestcallapi.service';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PopUpComponent } from '../pop-up/pop-up.component';
import { AuthService } from '@auth0/auth0-angular';
import { SmsService } from '../services/sms.service';
import { HttpErrorResponse } from '@angular/common/http';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ContactFormService } from '../services/contact-form.service';
import { ZendeskTicketBody } from '../models/zendesk-ticket-body.model';
import { environment } from '../../environments/environment';
import { CallbackEmailBody } from '../models/callback-email-body';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentPopupComponent } from '../payment-popup/payment-popup.component';




@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  imports: [
    HeaderComponent,
    FooterComponent,
    CommonModule,
    ReactiveFormsModule,
    NgIf,
    HttpClientModule,
    RouterLink,
    PopUpComponent,

    MatInputModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
  ],
})
export class DashboardComponent {
  disabledDates: Date[] = [
    new Date('11/28/2024'), // Thanksgiving Day (already in holidays)
    new Date('11/29/2024'), // Day after Thanksgiving
    new Date('12/24/2024'), // Christmas Eve
    new Date('12/25/2024'), // Christmas Day (already in holidays)
    new Date('01/01/2025'),
    new Date('01/20/2025'),
    new Date('02/17/2025'),
    new Date('05/26/2025'),
    new Date('06/19/2025'),
    new Date('07/04/2025'),
    new Date('09/01/2025'),
    new Date('11/27/2025'),
    new Date('11/28/2025'),
    new Date('12/24/2025'),
    new Date('12/25/2025')
  ];

  timeOptions = [
    { value: '', viewValue: 'Select time' },
    { value: '9:00 AM CST', viewValue: '9:00 AM CST' },
    { value: '9:30 AM CST', viewValue: '9:30 AM CST' },
    { value: '10:00 AM CST', viewValue: '10:30 AM CST' },
    { value: '10:30 AM CST', viewValue: '10:30 AM CST' },
    { value: '11:00 AM CST', viewValue: '11:00 AM CST' },
    { value: '11:30 AM CST', viewValue: '11:30 AM CST' },
    { value: '12:00 PM CST', viewValue: '12:00 PM CST' },
    { value: '12:30 PM CST', viewValue: '12:30 PM CST' },
    { value: '01:00 PM CST', viewValue: '01:00 PM CST' },
    { value: '01:30 PM CST', viewValue: '01:30 PM CST' },
    { value: '02:00 PM CST', viewValue: '02:00 PM CST' },
    { value: '02:30 PM CST', viewValue: '02:30 PM CST' },
    { value: '03:00 PM CST', viewValue: '03:00 PM CST' },
    { value: '03:30 PM CST', viewValue: '03:30 PM CST' },
    { value: '04:00 PM CST', viewValue: '04:00 PM CST' },
    { value: '04:30 PM CST', viewValue: '04:30 PM CST' },
    { value: '05:00 PM CST', viewValue: '05:00 PM CST' },
    { value: '05:30 PM CST', viewValue: '05:30 PM CST' },
  ];

  reasonOptions = [
    { value: '', viewValue: 'Select reason' },
    { value: 'System Support', viewValue: 'System Support' },
    { value: 'Billing Inquiry', viewValue: 'Billing Inquiry' },
  ];

  languageOptions = [
    { value: '', viewValue: 'Select language' },
    { value: 'English', viewValue: 'English' },
    { value: 'Spanish/Español', viewValue: 'Spanish/Español' },
  ];

  showPhoneIcon = true;

  requestPhoneCall!: FormGroup;
  minDate: Date;
  maxDate: Date;
  isCallNowDisabled: boolean;
  showMessage: boolean;
  message: string;

  ticketBody: ZendeskTicketBody | null = null;
  emailBody: CallbackEmailBody | null = null;
  reason = '';

  isUserLoggedIn = false;
  token = '';
  userEmail = '';
  createUserValue = '';
  userOptStatus = '';
  userName = '';
  loading = false;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private smsService: SmsService,
    private fb: FormBuilder,
    private apiService: RequestcallapiService,
    private contactFormService: ContactFormService
  ) {
    this.requestPhoneCall = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      accountNumber: [''],
      requestCall: ['', Validators.required],
      callDate: [''],
      callTime: [''],
      reason: ['', Validators.required],
      language: [''],
    });

    const currentDate = new Date();

    // Set the minimum date to 2 days from the current date
    this.minDate = new Date(currentDate);
    this.minDate.setDate(this.minDate.getDate() + 2);

    // Set the maximum date to 30 days from the current date
    this.maxDate = new Date(currentDate);
    this.maxDate.setDate(this.maxDate.getDate() + 30);

    this.isCallNowDisabled = this.checkIfCallNowShouldBeDisabled();
    this.showMessage = false;
    this.message = '';
  }

  ngAfterViewInit(): void {
    const element = document.getElementById('btnDashboard');
    if (element) {
      element.style.display = 'none';
    }
  }

  dateFilter = (d: Date | null): boolean => {
    const date = d || new Date();

    // Disable Saturday (6) and Sunday (0)
    const day = date.getDay();
    if (day === 0 || day === 6) {
      return false;
    }

    if (date >= this.minDate && date <= this.maxDate) {
      // Disable if it matches any date in the disabled dates array
      return !this.disabledDates.some(
        (disabledDate) =>
          d?.getDate() === disabledDate.getDate() &&
          d?.getMonth() === disabledDate.getMonth() &&
          d?.getFullYear() === disabledDate.getFullYear()
      );
    } else {
      return false;
    }
  };

  toggleIcons() {
    this.showPhoneIcon = !this.showPhoneIcon;
  }

  formatDate(date: Date): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(PopUpComponent, {
      width: '700px',
      data: {
        title: "DON'T MISS IMPORTANT UPDATES ABOUT YOUR ACCOUNT",
        userStatus: this.userOptStatus,
        emailAddress: this.userEmail,
        requestToken: this.token,
        userName: this.userName,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('This dialog was closed');
    });
  }

  openDialogAndRedirectOnClose(): void {
    const dialogRef = this.dialog.open(PaymentPopupComponent, {
      width: '700px',
      data: {
        title: "IMPORTANT MESSAGE"
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      window.open('https://3282543.ecommerce.zuora.com/auth/auth0', '_blank');
    });
  }

  ngOnInit(): void {
    this.onChanges();
    this.authService.getAccessTokenSilently().subscribe((response) => {
      this.token = response;

      this.authService.user$.subscribe((userProfile) => {
        this.userEmail = userProfile?.email ? userProfile.email : '';
        this.userName = userProfile?.name ? userProfile.name : '';

        this.smsService.getUserData(this.token, this.userEmail).subscribe({
          next: (response) => {
            this.userOptStatus = response.data.status;
          },
          error: (errorResponse: HttpErrorResponse) => {
            this.userOptStatus = errorResponse?.error?.data?.status;
            this.createUserValue = errorResponse?.error?.data?.createUser;

            if (this.userOptStatus === null) {
              this.openDialog();
            }
          },
        });
      });
    });
  }

  onChanges(): void {
    this.requestPhoneCall
      .get('requestCall')!
      .valueChanges.subscribe((value) => {
        if (value === 'schedule') {
          this.requestPhoneCall
            .get('callDate')!
            .setValidators([Validators.required]);
          this.requestPhoneCall
            .get('callTime')!
            .setValidators([Validators.required]);
        } else {
          this.requestPhoneCall.get('callDate')!.clearValidators();
          this.requestPhoneCall.get('callTime')!.clearValidators();
        }
        this.requestPhoneCall.get('callDate')!.updateValueAndValidity();
        this.requestPhoneCall.get('callTime')!.updateValueAndValidity();
      });
  }

  scrubPhoneNumber(input: string): string | null {
    // Remove all non-digit characters using regex
    const scrubbedNumber = input.replace(/\D/g, '');

    return scrubbedNumber;
  }

  submitForm() {
    if (this.requestPhoneCall.valid) {
      this.loading = true;
      setTimeout(() => {
        if (this.requestPhoneCall.value.requestCall == 'now') {
          this.requestPhoneCall.value.callDate = new Date();
          this.requestPhoneCall.value.callTime = '9:00 AM CST';
        }

        const formValue = this.requestPhoneCall.value;
        formValue.phoneNumber = this.scrubPhoneNumber(formValue.phoneNumber);

        if (this.requestPhoneCall.value.requestCall == 'now') {
          this.apiService.postData(formValue).subscribe(
            (response) => {
              console.log('API response:', response);
              this.showMessage = true;
              this.message =
                "You've been added to the queue, and we'll call you once an agent is available";
              this.loading = false;
            },
            (error) => {
              let errorText = error.error.text;
              if (errorText.includes('Failed')) {
                this.loading = false;
                alert('Something went wrong, please try again!');
              } else if (error.status == 200 && !errorText.includes('Failed')) {
                this.showMessage = true;
                this.message =
                  "You've been added to the queue, and we'll call you once an agent is available";
                this.loading = false;
              }
            }
          );
        } else if (this.requestPhoneCall.value.requestCall == 'schedule') {
          formValue.fullName = `${formValue.firstName} ${formValue.lastName}`;

          this.ticketBody = {
            type: 'incident',
            subject: `Schedule a callback for - ${formValue.fullName}`,
            group_id: environment.callbackGroup,
            ticket_form_id: environment.ticket,
            custom_fields: [],
            comment: this.getComment(this.requestPhoneCall),
          };

          this.reason = 'Schedule CallBack';

          this.emailBody = {
            subject: `Schedule a callback for ${formValue.fullName}`,
            body: `<img class="size-full wp-image-1678 alignright" src="https://sprucepower.wpengine.com/wp-content/uploads/2024/10/Spruce-Logo-White.png" alt="" width="209" height="64" />
              &nbsp
              Dear ${formValue.fullName},
              Thank you for connecting with us! Your future callback on ${
                formValue.callDate
              } at ${
              formValue.callTime
            } is now confirmed. We’ll call you at the number provided, ${this.scrubPhoneNumber(
              formValue.phoneNumber
            )}, to discuss your ${formValue.reason} request.
              If you need to contact a member of our Homeowner Support Team sooner, please know you’re welcome to contact us at (888) 636-0336, email support@sprucepower.com, or live-chat with an agent at sprucepower.com. We are open Monday through Thursday 9 AM to 8 PM Central Time and Friday 9 AM to 6 PM Central.
              Have a great day!
              Spruce Power`,
            to: [this.userEmail],
          };

          this.contactFormService
            .createZendeskTicket(this.ticketBody, this.reason, this.emailBody)
            .subscribe({
              next: (response) => {
                this.showMessage = true;
                this.message =
                  "Thank you for schedulling your callback. We'll call you at your preferred date and time.";
                this.loading = false;
              },
              error: (errorResponse: HttpErrorResponse) => {
                alert('Unable to submit the form, please try again!');
              },
            });
        }
      }, 2000);
    } else {
      this.markAllAsTouched();
    }
  }

  markAllAsTouched(): void {
    Object.keys(this.requestPhoneCall.controls).forEach((field) => {
      const control = this.requestPhoneCall.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  checkIfCallNowShouldBeDisabled(): boolean {
    const currentDate = new Date();
    const cstDate = this.convertToCST(currentDate);
    const currentDay = cstDate.getDay(); // 0 for Sunday, 6 for Saturday
    const currentHour = cstDate.getHours(); // 0-23

    //function to get the date in YYYY-MM-DD format
    function getDateString(date: Date): string {
      return date.toISOString().split('T')[0];
    }

    //get current date in string format
    const currentDateInString = getDateString(cstDate);

    //check if current date is existing in the disable dates array
    const isCurrentDateInDisabledDates = this.disabledDates.some(date => getDateString(date) === currentDateInString);

    if (currentDay === 0 || currentDay === 6 || isCurrentDateInDisabledDates) {
      return true; // Disable if it's Saturday, Sunday or current date in disable dates list
    }

    if (currentHour < 9 || currentHour > 18) {
      return true; // Disable if before 9 AM or after 6 PM
    }

    return false;
  }

  isDST(date: Date): boolean {
    const jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== date.getTimezoneOffset();
  }

  // Function to convert a given date to Central Standard Time (CST)
  convertToCST(date: Date): Date {
    const isDst = this.isDST(date);
    const offsetHours = date ? -5 : -6; // CST or CDT offset

    // Create a new date object with the adjusted time
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours() + offsetHours,
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
  }

  noWeekends(control: AbstractControl): { [key: string]: boolean } | null {
    const date = new Date(control.value);
    const day = date.getDay();
    if (day === 0 || day === 6) {
      return { weekend: true };
    }
    return null;
  }

  navigateToBilling() {
    this.openDialogAndRedirectOnClose();
  }

  getComment(formSelections: FormGroup) {
    let body = `First Name : ${
      formSelections.get('firstName')?.value
    }, Last Name: ${
      formSelections.get('lastName')?.value
    }, Phone Number: ${this.scrubPhoneNumber(
      formSelections.get('phoneNumber')?.value
    )}, When do you want a callback: Schedule later, Schedule Date: ${
      formSelections.get('callDate')?.value
    }, Schedule Time: ${
      formSelections.get('callTime')?.value
    }, Reason for request: ${
      formSelections.get('reason')?.value
    }, Language to be used on contact: ${
      formSelections.get('language')?.value
    }`;
    let comment = {
      body: body,
      public: false,
      uploads: null
    };

    return comment;
  }
}
